import {
  REGULATORY_REGISTER_ROWS,
  regulationChipAccessibleName,
  type RegulationChipKey,
} from './regulationCopy';

/**
 * SIL-611 — inline regulation reference chip (design option 1c). A bare
 * link, never a tooltip (decision 10) — the substantive legal text lives in
 * the register row (`RegulatoryRegisterCard`), not here. Renders only where
 * a disposal / end-of-life figure is actually shown; callers are
 * responsible for that placement decision (never on resale/repurpose rows
 * — see SIL-611 decision 8).
 */
export function RegulationChip({ regulationKey }: { regulationKey: RegulationChipKey }) {
  const row = REGULATORY_REGISTER_ROWS.find((r) => r.key === regulationKey);
  if (!row) return null;

  return (
    <a
      href={row.referenceUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={regulationChipAccessibleName(row.referenceLabel)}
      data-testid={`regulation-chip-${regulationKey}`}
      className="inline-flex items-center rounded border border-zinc-300 bg-white px-1.5 py-0.5 text-xs font-medium text-zinc-600 hover:bg-zinc-50"
    >
      {row.referenceLabel}
    </a>
  );
}
